// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "hr[data-v-f2f24336]{margin-top:1rem}", ""]);
// Exports
module.exports = exports;
